var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.$route.path === '/20201109QSNJJ/home')?_c('div',{staticClass:"banner"}):_vm._e(),_c('keep-alive',[_c('router-view',{staticStyle:{"height":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }